import { useEffect, useState, useMemo } from "react";
import { getBreakpoints } from "@shared/utils/getBreakpoints";

type BreakpointKey = "sm" | "md" | "lg" | "xl" | "2xl";

export function useBreakpoint(breakpointKey: BreakpointKey) {
  const breakpoints = useMemo(() => getBreakpoints(), []);

  const [isActive, setIsActive] = useState(false);

  const breakpointValue = breakpoints[breakpointKey];

  useEffect(() => {
    if (!breakpointValue) return;

    const mediaQuery = window.matchMedia(`(min-width: ${breakpointValue}px)`);

    setIsActive(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setIsActive(e.matches);

    mediaQuery.addEventListener("change", handler);

    return () => mediaQuery.removeEventListener("change", handler);
  }, [breakpointKey, breakpointValue]);

  return isActive;
}
